import { FlightCancellationConfig } from '@pv-frontend/flights-cancellation';

export const flightCancellationConfig: FlightCancellationConfig = {
  flightHeader: {
    container: {
      style: {
        background: 'var(--flight-cancellation-header-backGround)',
        color: 'var(--flight-cancellation-header-text-color)',
        padding: '1.56rem 6.13rem 1.25rem',
      },
    },
    backButton: {
      style: {
        background: 'transparent',
        color: 'var(--flight-cancellation-header-text-color)',
      },
    },
  },
  tabView: {
    orientation: 'vertical',
  },
  flightCard: {
    container: {
      style: {
        backgroundColor: 'var(--surface-a)',
        boxShadow: '0 1px 2px var(--flight-cancellation-card-shadow)',
        width: '400px', // Fixed width for desktop
        maxWidth: '100%', // Responsive on smaller screens
      },
    },
    flightStatusPartial: {
      style: {
        background: 'var(--flight-cancellation-partial-status-backGround)',
        border: '1px solid var(--flight-cancellation-partial-status-border)',
        width: 'fit-content',
      },
      config: {
        text: '',
      },
    },

    flightStatusNegative: {
      style: {
        background: 'var(--flight-cancellation-negative-status-backGround)',
        border: '1px solid var(--flight-cancellation-negative-status-border)',
        width: 'fit-content',
      },
      config: {
        text: ' Non-Cancellable',
      },
    },
    pnr: {
      style: {
        border: '1px solid var(--tile-border-dark-translucent)',
        background: 'var(--tile-background-dark-translucent)',
        height: '20px',
      },
    },
    dottedLine: {
      enabled: true,
      style: {
        borderRight: '2px dotted var(--surface-300)',
        borderColor: '#cccccc',
        height: '100%',
        width: '1px',
        opacity: '1',
      },
    },
  },
  rightSection: {
    leftBorder: {
      enabled: true,
      style: {
        borderLeftColor: 'var(--gray-200)',
        borderLeftWidth: '1px',
        borderLeftStyle: 'solid',
      },
    },
  },

  manualCancellationConfig: {
    cancelText: 'Call us to cancel your ticket',
    mobile: '+91 9820541839',
    supportText: 'or write to us at',
    merchantEmail: 'support@yatra.com',
  },

  spinnerConfig: {
    width: '50px',
    height: '50px',
  },
};
